<template>
    <section>
        <v-dialog v-model="answersDialog" max-width="750">
            <v-data-table
                hide-default-footer
                :headers="answersTableHeaders"
                :items="Answers"
            >
                <template v-slot:[`item.name`]="{ item }">
                    <v-list
                        two-line
                        max-width="350px"
                        class="transparent my-0 py-0"
                    >
                        <v-list-item class="px-0">
                            <v-list-item-content class="d-block d-md-none mr-2">
                                <v-list-item-title
                                    class="primary--text text--darken-1 font-weight-medium"
                                    v-html="item.name"
                                ></v-list-item-title>
                            </v-list-item-content>

                            <v-list-item-content class="d-none d-md-block ml-3">
                                <v-list-item-title
                                    class="text--darken-1 font-weight-medium"
                                    v-html="item.name"
                                ></v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </template>
                <template v-slot:[`item.action`]="{ item }">
                    <v-hover v-slot:default="{ hover }">
                        <v-btn
                            text
                            icon
                            :color="hover ? 'accent' : 'blue-grey'"
                            @click.stop="editAnswer(item)"
                        >
                            <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                    </v-hover>

                    <v-hover v-slot:default="{ hover }">
                        <v-btn
                            text
                            icon
                            :color="hover ? 'error' : 'blue-grey'"
                            @click.stop="deleteAnswer(item)"
                        >
                            <v-icon>mdi-trash-can-outline</v-icon>
                        </v-btn>
                    </v-hover>
                </template>
            </v-data-table>

            <v-container style="background-color: white">
                <v-row justify="end" class="pr-4">
                    <v-hover v-slot:default="{ hover }">
                        <v-btn
                            text
                            rounded
                            class="mr-1"
                            :color="hover ? 'error' : 'grey'"
                            @click="closeDialog"
                            >Cerrar</v-btn
                        >
                    </v-hover>

                    <v-hover v-slot:default="{ hover }">
                        <v-btn
                            rounded
                            :loading="loading"
                            :disabled="loading"
                            color="success"
                            :class="hover ? 'shadow-2' : 'shadow-4'"
                            class="px-8"
                            @click.stop="registerAnswer()"
                            >Añadir</v-btn
                        >
                    </v-hover>
                </v-row>
            </v-container>
        </v-dialog>

        <AnswersForm
            :formDialog="formDialog"
            @answerFormDialog:close="closeFormDialog"
            :dataToForm="dataToForm"
            :mode="formMode"
            :idQuestion="idQuestion"
        />
        <DeleteAnswer 
        v-if="deleteDialog"
        :dialogProp="deleteDialog"
        :item="itemToDelete"
        @deleteAnswerdialog:close="closeDeleteDialog"
        />
    </section>
</template>

<script>
import AnswersForm from "@/components/Answers/AnswersForm";
import DeleteAnswer from "@/components/Answers/DeleteAnswer";
export default {
    components: { AnswersForm, DeleteAnswer },
    props: {
        answersDialog: {
            type: Boolean,
            default: false
        },
        idQuestion: {
            type: Number
        }
    },
    data() {
        return {
            answersTableHeaders: [
                {
                    text: "Repuesta",
                    align: "left",
                    sortable: true,
                    value: "name",
                    class: "primary--text",
                    width: "50%"
                },
                {
                    text: "Valor",
                    align: "left",
                    sortable: true,
                    value: "value",
                    class: "primary--text",
                    width: "25%"
                },
                {
                    text: "Acciones",
                    align: "left",
                    value: "action",
                    class: "primary--text",
                    width: "25%"
                }
            ],
            formMode: "",
            formDialog: false,
            dataToForm: {},
            deleteDialog: false,
            itemToDelete: null
        };
    },
    created() {
        if (
            this.idQuestion > 0 &&
            !this.Answers.some(
                ans => ans.question_id === Number(this.idQuestion)
            )
        )
            this.getAnswers();
    },
    computed: {
        Answers() {
            return this.$store.getters["answers/GET_ANSWERS"];
        }
    },
    methods: {
        deleteAnswer(item) {
            this.deleteDialog = true,
            this.itemToDelete = item
        },
        closeDeleteDialog(){
            this.deleteDialog = false,
            this.itemToDelete = null
        },
        closeFormDialog() {
            this.formDialog = false;
            this.dataToForm = {};
            this.itemToDelete = false;
        },
        registerAnswer() {
            this.formMode = "register";
            this.formDialog = true;
        },
        editAnswer(item) {
            this.formDialog = true;
            this.formMode = "edit";
            this.dataToForm = item;
        },
        closeDialog() {
            this.$emit("dialog:close");
        },
        async getAnswers() {
            const res = await this.$store.dispatch(
                "answers/SHOW_ANSWERS",
                this.idQuestion
            );
        }
    }
};
</script>
